export default {"src":"/_next/static/media/fire.7e5e9e38.svg","height":21,"width":15,"blurWidth":0,"blurHeight":0};